import { fetchSessionJson } from '../SessionRequest';
import { toRequiredPositiveInteger } from '../Utilities';
import type { ReportDefinition } from '../../types/ReportDefinition';

const API_SERVER = process.env.API_SERVER || '';

export async function getReports(
  subscriptionId: number | string | null | undefined,
  schoolId: number | string | null | undefined
): Promise<ReportDefinition[]> {
  const validatedSubscriptionId = toRequiredPositiveInteger(subscriptionId, 'subscriptionId');
  const validatedSchoolId = toRequiredPositiveInteger(schoolId, 'schoolId');

  return fetchSessionJson<ReportDefinition[]>(
    `${API_SERVER}/subscriptions/admin/subscriptions/${validatedSubscriptionId}/schools/${validatedSchoolId}/reports`,
    'Failed to fetch school reports'
  );
}

const SchoolReportService = { getReports };

export default SchoolReportService;
